import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";

// The function this hook returns can be used to invalidate the private and public apps query and refetch it, which is
// necessary when a new connection is created or an existing connection is reconnected on the apps page.

export const useRefetchPublicAndPrivateApps = () => {
  const queryClient = useQueryClient();

  // Refetch public apps
  const publicAppsKey = getQueryKey(trpc.app.publicApps, undefined, "any");
  // Refetch private apps
  const privateAppsKey = getQueryKey(trpc.app.privateApps, undefined, "any");
  // Refetch implementations meta
  const implementationsMetaKey = getQueryKey(
    trpc.implementationMeta.getPrivateImplementationsMeta,
    undefined,
    "any",
  );
  // Refetch appStats
  const appStatsKey = getQueryKey(trpc.app.appStats, undefined, "any");
  //

  const refetchPublicAndPrivateApps = () => {
    queryClient.cancelQueries({ queryKey: publicAppsKey });
    queryClient.cancelQueries({ queryKey: privateAppsKey });
    queryClient.cancelQueries({ queryKey: implementationsMetaKey });
    queryClient.cancelQueries({ queryKey: appStatsKey });
    queryClient.invalidateQueries({
      queryKey: publicAppsKey,
      refetchType: "all",
    });
    queryClient.invalidateQueries({
      queryKey: privateAppsKey,
      refetchType: "all",
    });
    queryClient.invalidateQueries({
      queryKey: implementationsMetaKey,
      refetchType: "all",
    });
    queryClient.invalidateQueries({
      queryKey: appStatsKey,
      refetchType: "all",
    });
  };

  return { refetchPublicAndPrivateApps };
};
